import { render, staticRenderFns } from "./smart-insertion.vue?vue&type=template&id=17960e13"
import script from "./smart-insertion.vue?vue&type=script&lang=js"
export * from "./smart-insertion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports